import styled from 'styled-components';

export const SidebarContainer = styled.div`
  font-size: ${({ theme }) => theme.fontSize.nm};
  padding: 24px 0 12px;
  max-width: 370px;
  margin-bottom: 16px;

  &.hide {
    display: none;
  }

  background-color: ${({ theme }) => theme.colors.color_pale_blue};
  border-radius: 8px;

  table {
    margin: 0 24px;
  }

  td:first-of-type {
    width: 95px;
  }

  td {
    min-width: 84px;
    padding-bottom: 12px;
    vertical-align: top;
  }

  .bold {
    font-weight: bold;
  }

  .pale {
    opacity: 0.5;
  }

  .transparent {
    opacity: 0.5;
  }

  .break {
    word-break: break-word;
  }

  .bottom {
    vertical-align: bottom;
  }

  @media (max-width: 1024px) {
    max-width: 100%;
    width: 100%;
  }

  @media (max-width: 512px) {
    border-radius: 0;
    padding: 16px 0 10px;
    font-size: ${({ theme }) => theme.fontSize.sm};

    table {
      margin: 0 8px;
    }
  }
`;

export const HR = styled.div`
  border-top: 1px solid rgba(22%, 27%, 31%, 0.1);
  margin-bottom: 16px;

  &.hide {
    display: none;
  }
`;

export const SidebarSection = styled.div`
  &.hide,
  .hide {
    display: none;
  }

  @media (max-width: 1024px) {
    &.can-be-hidden.hide-under-button,
    .hide-under-button {
      display: none;
    }
  }
`;

export const MoreBtnWrapper = styled.div`
  display: none;
  padding: 0 14px 14px 21px;

  @media (max-width: 1024px) {
    display: block;
  }

  @media (max-width: 512px) {
    padding: 8px;
    font-size: ${({ theme }) => theme.fontSize.sm};
  }
`;
